











































































import Vue from 'vue';
import Component from 'vue-class-component';
import Modal from '@/components/UI/Modal.vue';
import device from '@/store/modules/device';
import ui from '@/store/modules/ui';
import loyalty from '@/store/modules/loyalty';
import { LoyaltyBenefit, Tooltip } from '@/store/models';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';

@Component({
    components: {
        Modal
    }
})
export default class LoyaltyBenefits extends Vue {
    private loading: boolean = false;

    get loyaltyBenefitsCheckbox(): LoyaltyBenefit[] {
        return loyalty.customerBenefits.filter((benefit: LoyaltyBenefit) => {
            return benefit.checkbox;
        });
    }

    get isMobile() {
        return device.isMobile;
    }

    get isLoading(): boolean {
        return cart.loadingFlags.totals || this.loading;
    }

    public isBenefitAvailable(benefit: LoyaltyBenefit) {
        if (
            !benefit.is_selected &&
            benefit.benefit_type === 'free_shipping' &&
            checkout.selectedShippingMethod &&
            checkout.selectedShippingMethod.amount === 0
        ) {
            return false;
        }

        return true;
    }

    public getTooltipLabel(tooltip: any) {
        if (tooltip) {
            const storeCode = cart.storeId.toString();
            const tooltipLabel = tooltip.find((t: Tooltip) => t.store === storeCode);

            if (tooltipLabel) {
                return tooltipLabel.tooltip_label;
            }

            return '';
        }

        return '';
    }

    private benefitUses(benefit: LoyaltyBenefit): number {
        return benefit.uses + Number(this.isSelected(benefit));
    }

    private isSelected(benefit: LoyaltyBenefit) {
        return benefit.is_selected;
    }

    private isUsedUp(benefit: LoyaltyBenefit) {
        if (benefit.max_uses) {
            return benefit.max_uses > 0 && benefit.uses >= benefit.max_uses;
        }

        return false;
    }

    private async changeLoyaltyBenefit(benefit: LoyaltyBenefit) {
        // Safeguard to stop users from using expired benefits
        if (this.isUsedUp(benefit)) {
            return;
        }

        this.loading = true;
        cart.flagLoading({ key: 'totals', value: true });

        // Change local checkbox status
        benefit.is_selected = !benefit.is_selected;

        // Update quote benefit status
        await loyalty.updateQuoteBenefit(benefit);

        cart.flagLoading({ key: 'totals', value: false });
        this.loading = false;
    }

    private openModal(modalId: string) {
        if (this.isMobile) {
            ui.openModal(modalId);
        }
    }

    private closeModal(modalId: string) {
        ui.closeModal(modalId);
    }

    private async mounted() {
        const benefitsPromises = loyalty.customerBenefits.reduce<Array<Promise<void>>>((acc, benefit) => {
            if (!benefit.checkbox) {
                acc.push(loyalty.updateQuoteBenefit(benefit));
            }

            return acc;
        }, []);

        await Promise.all(benefitsPromises);
    }
}
